/* import { FcGoogle } from "react-icons/fc";
import { FaFacebookF } from "react-icons/fa";
import InputField from "../components/input/InputField";
import { useState, useEffect } from "react";
import { BsEyeSlash, BsEye, BsPerson } from "react-icons/bs";
import { signInURL } from "../api/endpoints";
import { useNavigate } from "react-router-dom";
import { setUser } from "../slice/webStoreUserSlice";
import { useDispatch } from "react-redux";
import { ButtonLoader } from "../components/uxCollections/Loaders";
import backImage from "../assetsStatic/bgImage.webp";
import { ArrowBigRight } from "lucide-react";
import { uiAlert } from "../components/alerts/customAlert/uiAlert";
import ForgotPasswordOverlay from "./ForgotPassword";

const SignIn = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [isEmailValid, setIsEmailValid] = useState(true); //
  const [password, setPassword] = useState("");
  const [isPasswordIncorrect, setIsPasswordIncorrect] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showOverlayToResetPassword, setShowOverlayToResetPassword] = useState(false);

  const regexForEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;

  console.log(window.location.pathname);

  useEffect(() => {
    if (regexForEmail.test(email)) {
      setIsEmailValid(true);
    } else {
      email.length > 4 && setIsEmailValid(false);
      setIsFormValid(false);
    }
  }, [email]);

  useEffect(() => {
    console.log(password);
    if (email && password.length > 4 && isEmailValid) {
      setIsFormValid(true);
    } else {
      setIsFormValid(false);
    }
  }, [isEmailValid, password]);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleSignIn = async () => {
    setIsLoading(true);
    try {
      console.log(email, password);
      let response = await fetch(signInURL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email: String(email).trim().toLowerCase(), password }),
      });
      if (response.status === 201) {
        const data = await response.json();
        console.log(data);
        localStorage.setItem("refreshToken", data.refreshToken);
        localStorage.setItem("accessToken", data.accessToken);
        localStorage.setItem("lastInteractionAt", Date.now().toString());
        dispatch(setUser(data.user));
        navigate("/mystores");
      } else if (response.status === 401) {
        setIsPasswordIncorrect(true);
        uiAlert("password incorrect", "error");
       
      } else if (response.status === 404) {
        uiAlert("user not found", "error");
     
      } else {
        uiAlert("Something unexpected has occurred, please try again later", "error");
       
        return;
      }
    } catch (error) {
      uiAlert("Something unexpected has occurred, please try again later", "error");
      return;
    } finally {
      setIsLoading(false);
      setPassword("");
    }
  };

  return (
    <>
    
      <div className='signInDivWrapper'>
        <img src={backImage} className='bgImage84' />
        <div className='signinForm'>
          <div style={{ textAlign: "center" }}>
            
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "8px" }}>
              <div>
                
                
                <img
                  style={{
                    width: "40px",
                  }}
                  src='/StorelenseLogo.png'
                  alt='Company Ad'
                />
              </div>
              <div>
                <p style={{ fontSize: "1.4rem", fontWeight: "600" }}>
                  <span style={{ color: "#0D49B5", fontWeight: "700" }}>Store</span>
                  <span style={{ color: "#37B4C5", fontWeight: "700" }}>Lense</span>
                </p>
              </div>
            </div>
          </div>
         
      
          <p style={{ fontSize: "1.3rem", marginBottom: "28px" }} className='titleSign'>
            Sign in to access your account
          </p>

          <div
            onClick={() => {
              window.location.replace("https://www.staff.storelense.com/sign-in");
            }}
            style={{ color: "rgb(14, 73, 181)" }}
            className='signinSocials'
          >
            <BsPerson size={20} />
            <p>Go to staff Portal</p>
            <ArrowBigRight color='rgb(14, 73, 181)' />
          </div>
       
          <p></p>
          <InputField style={{ top: "18px" }} placeholder={"Email *"} setValue={setEmail} value={email} type={"text"} newStyle={JSON.stringify({})} />
          {!isEmailValid && email.length > 4 && (
            <p style={{ alignSelf: "flex-start" }} className='emailValidationP'>
              Email not valid
            </p>
          )}
          <div className='inputFieldAnimated passwordIn'>
            <input
              onKeyDown={(e) => isFormValid && e.key === "Enter" && handleSignIn()}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              type={showPassword ? "text" : "password"}
              required={true}
            />
            <p>Password*</p>
            {showPassword ? (
              <BsEye style={{ cursor: "pointer" }} onClick={() => setShowPassword(false)} />
            ) : (
              <BsEyeSlash style={{ cursor: "pointer" }} onClick={() => setShowPassword(true)} />
            )}
          </div>
          <div
            onClick={() => {
              setShowOverlayToResetPassword(true);
            }}
            className='forgottenPassword'
          >
            <p>Forgotten password?</p>
          </div>
          {isFormValid ? (
            isLoading ? (
              <button style={{ opacity: "0.7", cursor: "not-allowed" }} className='signUpbutton'>
                {" "}
                <ButtonLoader />
              </button>
            ) : (
              <button id='signInButton2' onClick={() => handleSignIn()} className='signUpbutton'>
                {" "}
                Sign in
              </button>
            )
          ) : (
            <button style={{ opacity: "0.7", cursor: "not-allowed" }} className='signUpbutton'>
              {" "}
              Sign in
            </button>
          )}

          <p style={{ marginTop: "10px" }}>
            New to member?{" "}
            <span
              style={{ cursor: "pointer", color: "rgb(39, 88, 194)", fontWeight: "700", textDecoration: "underline", marginLeft: "5px" }}
              onClick={() => navigate("/sign-up")}
            >
              Register
            </span>
          </p>
        
        </div>
      </div>

      {showOverlayToResetPassword && (
        <ForgotPasswordOverlay onClose={() => setShowOverlayToResetPassword(false)} showOverlayToResetPassword={showOverlayToResetPassword} />
      )}
    </>
  );
};

export default SignIn; */

import { useState, useEffect } from "react";
import { BsEyeSlash, BsEye, BsPerson } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { ArrowBigRight } from "lucide-react";
import { signInURL } from "../api/endpoints";
import { setUser } from "../slice/webStoreUserSlice";
import { ButtonLoader, ButtonLoaderII } from "../components/uxCollections/Loaders";
import { uiAlert } from "../components/alerts/customAlert/uiAlert";
import ForgotPasswordOverlay from "./ForgotPassword";
import "../styles/LoginAndCreate/SignIn.css";

const ShelfUnit = ({ opacity = 1 }) => (
  <g opacity={opacity}>
    <rect x='0' y='0' width='10' height='500' fill='#5c2e1a' />
    <rect x='190' y='0' width='10' height='500' fill='#5c2e1a' />
    <rect x='0' y='0' width='200' height='10' fill='#8a4423' />
    <rect x='0' y='123' width='200' height='10' fill='#8a4423' />
    <rect x='0' y='246' width='200' height='10' fill='#8a4423' />
    <rect x='0' y='369' width='200' height='10' fill='#8a4423' />
    <rect x='0' y='490' width='200' height='10' fill='#8a4423' />

    <rect x='14' y='20' width='70' height='95' rx='6' fill='#ffb347' fillOpacity='0.95' />
    <rect x='96' y='35' width='60' height='80' rx='6' fill='#ff7a29' fillOpacity='0.95' />
    <rect x='26' y='45' width='46' height='8' fill='#ffffff' fillOpacity='0.5' />

    <rect x='14' y='143' width='58' height='75' rx='6' fill='#e0512b' fillOpacity='0.92' />
    <rect x='86' y='153' width='72' height='65' rx='6' fill='#ffb347' fillOpacity='0.95' />
    <rect x='98' y='170' width='48' height='7' fill='#ffffff' fillOpacity='0.5' />

    <rect x='20' y='266' width='66' height='95' rx='6' fill='#ff7a29' fillOpacity='0.95' />
    <rect x='102' y='278' width='64' height='83' rx='6' fill='#ffcf6b' fillOpacity='0.95' />
    <rect x='32' y='290' width='42' height='7' fill='#ffffff' fillOpacity='0.5' />

    <rect x='14' y='389' width='80' height='93' rx='6' fill='#ffb347' fillOpacity='0.95' />
    <rect x='106' y='399' width='56' height='83' rx='6' fill='#e0512b' fillOpacity='0.9' />
    <rect x='26' y='415' width='52' height='7' fill='#ffffff' fillOpacity='0.5' />
  </g>
);

const SignIn = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [isEmailValid, setIsEmailValid] = useState(true);
  const [password, setPassword] = useState("");
  const [isPasswordIncorrect, setIsPasswordIncorrect] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showOverlayToResetPassword, setShowOverlayToResetPassword] = useState(false);

  const regexForEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;

  useEffect(() => {
    if (regexForEmail.test(email)) {
      setIsEmailValid(true);
    } else {
      email.length > 4 && setIsEmailValid(false);
      setIsFormValid(false);
    }
  }, [email]);

  useEffect(() => {
    if (email && password.length > 4 && isEmailValid) {
      setIsFormValid(true);
    } else {
      setIsFormValid(false);
    }
  }, [isEmailValid, password]);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleSignIn = async () => {
    setIsLoading(true);
    setIsPasswordIncorrect(false);
    try {
      let response = await fetch(signInURL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email: String(email).trim().toLowerCase(), password }),
      });
      if (response.status === 201) {
        const data = await response.json();
        localStorage.setItem("refreshToken", data.refreshToken);
        localStorage.setItem("accessToken", data.accessToken);
        localStorage.setItem("lastInteractionAt", Date.now().toString());
        dispatch(setUser(data.user));
        navigate("/mystores");
      } else if (response.status === 401) {
        setIsPasswordIncorrect(true);
        uiAlert("password incorrect", "error");
      } else if (response.status === 404) {
        uiAlert("user not found", "error");
      } else {
        uiAlert("Something unexpected has occurred, please try again later", "error");
        return;
      }
    } catch (error) {
      uiAlert("Something unexpected has occurred, please try again later", "error");
      return;
    } finally {
      setIsLoading(false);
      setPassword("");
    }
  };

  return (
    <>
      <div className='signin-page'>
        <div className='signin-page__backdrop' aria-hidden='true'>
          <svg className='signin-page__aisle' viewBox='0 0 1000 700' preserveAspectRatio='xMidYMid slice'>
            <polygon points='0,700 1000,700 640,300 360,300' fill='#231708' />
            <polygon points='360,300 640,300 560,250 440,250' fill='#ffe29a' fillOpacity='0.55' />

            <g transform='translate(-30,180) scale(1.05)'>
              <ShelfUnit opacity={1} />
            </g>
            <g transform='translate(150,230) scale(0.72)'>
              <ShelfUnit opacity={0.75} />
            </g>
            <g transform='translate(300,255) scale(0.42)'>
              <ShelfUnit opacity={0.45} />
            </g>

            <g transform='translate(1030,180) scale(-1.05,1.05)'>
              <ShelfUnit opacity={1} />
            </g>
            <g transform='translate(850,230) scale(-0.72,0.72)'>
              <ShelfUnit opacity={0.75} />
            </g>
            <g transform='translate(700,255) scale(-0.42,0.42)'>
              <ShelfUnit opacity={0.45} />
            </g>
          </svg>
          <div className='signin-page__glow' />
          <div className='signin-page__vignette' />
        </div>

        <main className='signin-page__wrap'>
          <div className='signin-card'>
            <div className='signin-card__brand'>
              <img src='/StorelenseLogo.png' alt='StoreLense' />
              <span>
                Store<span>Lense</span>
              </span>
            </div>

            <h2 className='signin-card__title'>Welcome back</h2>
            <p className='signin-card__subtitle'>Sign in and keep an eye on your stores</p>

            <button type='button' className='signin-card__staff-link' onClick={() => window.location.replace("https://www.staff.storelense.com/sign-in")}>
              <BsPerson size={17} />
              <span>Go to staff portal</span>
              <ArrowBigRight size={17} />
            </button>

            <div className='signin-divider'>
              <span>or sign in with your admin account</span>
            </div>

            <div className={`signin-field ${!isEmailValid && email.length > 4 ? "signin-field--error" : ""}`}>
              <input id='signin-email' type='text' placeholder=' ' value={email} onChange={(e) => setEmail(e.target.value)} autoComplete='email' />
              <label htmlFor='signin-email'>Email</label>
            </div>
            {!isEmailValid && email.length > 4 && <p className='signin-field__message'>Enter a valid email address</p>}

            <div className={`signin-field ${isPasswordIncorrect ? "signin-field--error" : ""}`}>
              <input
                id='signin-password'
                type={showPassword ? "text" : "password"}
                placeholder=' '
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onKeyDown={(e) => isFormValid && e.key === "Enter" && handleSignIn()}
                autoComplete='current-password'
              />
              <label htmlFor='signin-password'>Password</label>
              <button
                type='button'
                className='signin-field__toggle'
                onClick={() => setShowPassword((v) => !v)}
                aria-label={showPassword ? "Hide password" : "Show password"}
              >
                {showPassword ? <BsEye size={17} /> : <BsEyeSlash size={17} />}
              </button>
            </div>
            {isPasswordIncorrect && <p className='signin-field__message'>Incorrect password, try again</p>}

            <button type='button' className='signin-card__forgot' onClick={() => setShowOverlayToResetPassword(true)}>
              Forgotten password?
            </button>

            <button type='button' className='signin-card__submit' disabled={!isFormValid || isLoading} onClick={handleSignIn}>
              {isLoading ? <ButtonLoaderII /> : "Sign in"}
            </button>

            <p className='signin-card__footer'>
              New to StoreLense?
              <span onClick={() => navigate("/sign-up")}> Register</span>
            </p>
          </div>
        </main>
      </div>

      {showOverlayToResetPassword && (
        <ForgotPasswordOverlay onClose={() => setShowOverlayToResetPassword(false)} showOverlayToResetPassword={showOverlayToResetPassword} />
      )}
    </>
  );
};

export default SignIn;

/* const logo = (
  <svg xmlns='http://www.w3.org/2000/svg' xlink='http://www.w3.org/1999/xlink' width='46' height='46' viewBox='0 0 46 46'>
    <defs>
      <filter id='Ellipse_272'>
        <feOffset dx='-1' dy='1' input='SourceAlpha' />
        <feGaussianBlur stdDeviation='5' result='blur' />
        <feFlood flood-color='#0f0f0f' flood-opacity='0.161' result='color' />
        <feComposite operator='out' in='SourceGraphic' in2='blur' />
        <feComposite operator='in' in='color' />
        <feComposite operator='in' in2='SourceGraphic' />
      </filter>
      <radialGradient
        id='radial-gradient'
        cx='0.862'
        cy='0.237'
        r='1.394'
        gradientTransform='translate(-0.13 0.179) rotate(-17.999)'
        gradientUnits='objectBoundingBox'
      >
        <stop offset='0' stop-color='#5070a1' />
        <stop offset='1' stop-color='#0e49b5' />
      </radialGradient>
      <filter id='Subtraction_13' x='0.877' y='3.011' width='28.944' height='28.862' filterUnits='userSpaceOnUse'>
        <feOffset dx='-3' input='SourceAlpha' />
        <feGaussianBlur stdDeviation='3' result='blur-2' />
        <feFlood flood-color='#434343' flood-opacity='0.161' />
        <feComposite operator='in' in2='blur-2' />
        <feComposite in='SourceGraphic' />
      </filter>
      <filter id='Subtraction_23' x='15.434' y='17.402' width='28.862' height='28.413' filterUnits='userSpaceOnUse'>
        <feOffset dy='3' input='SourceAlpha' />
        <feGaussianBlur stdDeviation='3' result='blur-3' />
        <feFlood flood-color='#464646' flood-opacity='0.161' />
        <feComposite operator='in' in2='blur-3' />
        <feComposite in='SourceGraphic' />
      </filter>
    </defs>
    <g id='Group_2614' data-name='Group 2614' transform='translate(-0.037 -0.1)'>
      <g data-type='innerShadowGroup'>
        <circle id='Ellipse_272-2' data-name='Ellipse 272' cx='23' cy='23' r='23' transform='translate(0.037 0.099)' fill='#fff' />
        <g transform='matrix(1, 0, 0, 1, 0.04, 0.1)' filter='url(#Ellipse_272)'>
          <circle id='Ellipse_272-3' data-name='Ellipse 272' cx='23' cy='23' r='23' transform='translate(0 0)' fill='#fff' />
        </g>
        <g id='Ellipse_272-4' data-name='Ellipse 272' transform='translate(0.037 0.099)' fill='none' stroke='#0e49b5' stroke-width='2'>
          <circle cx='23' cy='23' r='23' stroke='none' />
          <circle cx='23' cy='23' r='22' fill='none' />
        </g>
      </g>
      <circle id='Ellipse_273' data-name='Ellipse 273' cx='18' cy='18' r='18' transform='translate(5.037 5.099)' fill='#c8a027' />
      <circle id='Ellipse_274' data-name='Ellipse 274' cx='17.5' cy='17.5' r='17.5' transform='translate(6.037 5.099)' fill='#fff' />
      <g id='Group_2610' data-name='Group 2610' transform='translate(12.416 12.111)'>
        <g transform='matrix(1, 0, 0, 1, -12.38, -12.01)' filter='url(#Subtraction_13)'>
          <path
            id='Subtraction_13-2'
            data-name='Subtraction 13'
            d='M10.943,10.862H0A10.554,10.554,0,0,1,3.19,3.326,11.63,11.63,0,0,1,10.944,0V10.861h0Z'
            transform='translate(12.88 12.01)'
            fill='url(#radial-gradient)'
          />
        </g>
        <path
          id='Subtraction_25'
          data-name='Subtraction 25'
          d='M10.8,0H0A10.623,10.623,0,0,0,3.148,7.536,11.406,11.406,0,0,0,10.8,10.862V0h0Z'
          transform='translate(22.854 10.862) rotate(180)'
          fill='#37b4c5'
        />
        <path
          id='Subtraction_17'
          data-name='Subtraction 17'
          d='M10.412,10.862H0A10.87,10.87,0,0,1,10.413,0V10.861h0Z'
          transform='translate(0.58 21.805) rotate(-90)'
          fill='#37b4c5'
        />
        <g transform='matrix(1, 0, 0, 1, -12.38, -12.01)' filter='url(#Subtraction_23)'>
          <path
            id='Subtraction_23-2'
            data-name='Subtraction 23'
            d='M10.412,0H0A10.825,10.825,0,0,0,3.035,7.536a10.813,10.813,0,0,0,7.378,3.325V0h0Z'
            transform='translate(24.43 33.82) rotate(-90)'
            fill='#0e49b5'
          />
        </g>
        <path
          id='Subtraction_12'
          data-name='Subtraction 12'
          d='M22.232,0H0A10.218,10.218,0,0,0,3.405,7.138a11.416,11.416,0,0,0,7.711,2.936,11.416,11.416,0,0,0,7.711-2.936A10.217,10.217,0,0,0,22.232,0Z'
          transform='translate(23.528 10.636) rotate(180)'
          fill='#fff'
        />
        <path
          id='Subtraction_26'
          data-name='Subtraction 26'
          d='M22.232,10.075H0A10.218,10.218,0,0,1,3.4,2.936,11.416,11.416,0,0,1,11.116,0a11.415,11.415,0,0,1,7.711,2.936,10.218,10.218,0,0,1,3.4,7.138Z'
          transform='translate(22.232 21.268) rotate(180)'
          fill='#fff'
        />
        <path id='Path_3551' data-name='Path 3551' d='M0,0H22.416' transform='translate(0.499 11.014)' fill='none' stroke='#0e49b5' stroke-width='1' />
      </g>
    </g>
  </svg>
); */
